// @flow

import { useTranslator } from '@gandi/translate';

import {
  TextField,
  type Props as FieldProps,
} from 'src/Reshaped/Form/TextField';

type Props = {
  ...Partial<FieldProps>,
  name: string,
  placeholder?: string,
};

export function Email({
  control,
  label,
  name,
  placeholder,
  disabled,
  rules,
  help,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <TextField
      name={name}
      label={label}
      inputAttributes={{ type: 'email' }}
      inputProps={{ placeholder }}
      disabled={disabled}
      control={control}
      rules={{
        ...rules,
        pattern: {
          value: /^\S+@\S+$/i,
          message: __('Must use be a valid email'),
        },
      }}
      help={help}
    />
  );
}
